import { storageWrapper } from "./localstorage"
import get from "lodash.get"

const REDDIT_PIXEL_TRACK_KEY = "backervoice-reddit-pixel-tracker"

const tracker = () =>
  JSON.parse(storageWrapper.getItem(REDDIT_PIXEL_TRACK_KEY)) || {}

const wasTracked = code => {
  const redditTracker = tracker()

  return redditTracker[code] > 0
}

const incrementTracker = code => {
  const redditTracker = tracker()

  redditTracker[code] = redditTracker[code] + 1 || 1

  storageWrapper.setItem(REDDIT_PIXEL_TRACK_KEY, JSON.stringify(redditTracker))
}

export const setupRedditPixel = () => {
  /* eslint-disable */
  return !(function(w, d) {
    if (!w.rdt) {
      var p = (w.rdt = function() {
        p.sendEvent
          ? p.sendEvent.apply(p, arguments)
          : p.callQueue.push(arguments)
      })
      p.callQueue = []
      var t = d.createElement("script")
      ;(t.src = "https://www.redditstatic.com/ads/pixel.js"), (t.async = !0)
      var s = d.getElementsByTagName("script")[0]
      s.parentNode.insertBefore(t, s)
    }
  })(window, document)
  /* eslint-enable */
}

export const buildReddit = (conversions, ref) => {
  if (!window.rdt) {
    console.log("Reddit Pixel script not setup, setting it up...")
    setupRedditPixel()
  }

  if (wasTracked(ref)) {
    return
  }

  for (let i = 0; i < conversions.length; i++) {
    const pixel = conversions[i]
    const events = get(pixel, "request.data.events", [])

    events.forEach(({ user, type, metadata }) => {
      init(pixel.pixel_id, user)

      trackConversion(type.tracking_type, metadata.conversion_id)
    })
  }

  incrementTracker(ref)
}

const rdt = (...args) => {
  window.rdt(...args)
}

export const init = (pixelId, options) => {
  rdt("init", pixelId, options)
}

const track = (eventName, options) => {
  rdt("track", eventName, options)
}

const trackPageVisit = () => {
  track("PageVisit")
}

const trackConversion = (eventName, conversionId) => {
  track(eventName, { conversionId: conversionId })
}
